import { render } from "./SearchResultsView.vue?vue&type=template&id=5d5d75f8&scoped=true"
import script from "./SearchResultsView.vue?vue&type=script&lang=js"
export * from "./SearchResultsView.vue?vue&type=script&lang=js"

import "./SearchResultsView.vue?vue&type=style&index=0&id=5d5d75f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5d75f8"]])

export default __exports__